import SplashLayout2026 from "../Splash2026/SplashLayout2026";

interface Splash2x2026Props {
  id: string;
  zoom: number;
}

/** Releases splash, 2026 design, 1280x800 (@2x). The 2025 design of this canvas is Splash2x. */
const Splash2x2026 = ({id, zoom}: Splash2x2026Props) => (
  <SplashLayout2026 id={id} zoom={zoom} scale={2} fallbackTransformId="Splash2x" />
);

export default Splash2x2026;
